import React, { FC } from 'react';
import { Tabs } from '@components/atoms/Tabs';
import { useData } from '@hooks/useData';

interface TranslationTabsProps {
    contentByLanguage: { language: string; content: JSX.Element | JSX.Element[] }[];
}

export const TranslationTabs: FC<TranslationTabsProps> = ({ contentByLanguage }) => {
    const { allLanguages } = useData();

    const languagesToDisplay = allLanguages?.data?.filter((item) => item.default !== 1) || [];

    return (
        <Tabs
            tabs={
                languagesToDisplay.map((language) => {
                    return {
                        label: (
                            <>
                                {language.image ? (
                                    <img src={language.image} alt={language.language_name} />
                                ) : (
                                    language.language_code?.toUpperCase()
                                )}
                            </>
                        ),
                        content: (
                            <>
                                {
                                    contentByLanguage.find(
                                        (item) => item.language.toUpperCase() === language.language_code?.toUpperCase()
                                    )?.content
                                }
                            </>
                        ),
                    };
                }) || []
            }
        />
    );
};
